import { RestaurantSegmentEnum } from '@enums';

export enum SalesFocusTabEnum {
    CHAINS = 'chains',
    INDEPENDENTS = 'independents',
}

export const SECTION_TITLE = 'Sales Focus';
export const SUBSECTION_TITLE = 'Top Chains';
export const BY_SIZE_LABEL = 'by size';
export const TERRITORY_LABEL = 'Chains In My Territory';
export const EMPTY_CHAINS_MESSAGE = 'There are no chains headquartered in the selected territory';
export const MORE_CHAIN_TARGETS_LABEL = 'More Chain Targets';
export const CHAIN_MENU_GAP_TITLE = 'Chain Menu Gap';
export const CATEGORY_MENU_GAP_TITLE = 'Category Menu Gap';
export const CATEGORY_MENU_GAP_DESC =
    'Broad category level menu comparison between selected chain and top competitors';
export const CUSTOM_MENU_GAP_TITLE = 'Custom Menu Gap';
export const CUSTOM_MENU_GAP_DESC =
    'Detailed item level menu comparison between selected chain and top competitors';

export const INDEPENDENTS_SUBSECTION_TITLE = 'Top Units';
export const INDEPENDENTS_BY_LABEL = 'by total purchase potential';
export const INDEPENDENTS_TERRITORY_LABEL = 'Independents Overall';
export const EMPTY_INDEPENDENTS_MESSAGE = 'There are no independent restaurants in the selected territory';
export const MORE_RESTAURANTS_LABEL = 'More Restaurants';

export const INDEPENDENTS_SEGMENTS = [
    { id: RestaurantSegmentEnum.QUICK_SERVICE, title: 'Quick Service' },
    { id: RestaurantSegmentEnum.FAST_CASUAL, title: 'Fast Casual' },
    { id: RestaurantSegmentEnum.MIDSCALE_DINING, title: 'Midscale' },
    { id: RestaurantSegmentEnum.CASUAL_DINING, title: 'Casual Dining' },
    { id: RestaurantSegmentEnum.UPSCALE_CASUAL, title: 'Upscale Casual' },
    { id: RestaurantSegmentEnum.FINE_DINING, title: 'Fine Dining' },
];

export const SALES_FOCUS_TABS: Array<{ id: SalesFocusTabEnum; title: string; isDisabled?: boolean }> = [
    { id: SalesFocusTabEnum.CHAINS, title: 'Chains' },
    { id: SalesFocusTabEnum.INDEPENDENTS, title: 'Independents' },
];

export const ON_SITE_SUBSECTION_TITLE = 'On-Site Chains';
export const ON_SITE_BY_SIZE_LABEL = 'by size';
export const MORE_ON_SITE_TARGETS_LABEL = 'More On-Site Targets';
export const EMPTY_ON_SITE_CHAINS_MESSAGE = 'There are no on-site chains in the selected territory';
export const ON_SITE_C_STORE_TITLE = 'C-Store Chains';
export const ON_SITE_GROCERY_TITLE = 'Grocery Chains';
export const ON_SITE_LODGING_TITLE = 'Lodging Chains';

export const SALES_TARGETING_TITLE = 'Sales Targeting';
export const SAVED_SEARCHES_LABEL = 'Saved Searches';
export const START_NEW_SEARCH_LABEL = 'start a new search';
export const SAVED_SEARCHES_PERSONAL_LABEL = 'Personal';
export const SAVED_SEARCHES_COMPANY_LABEL = 'Company owned';
export const SAVED_SEARCHES_PAGE_SIZE = 15;
export const START_NEW_SEARCH_PATH = '/search';
